import React from 'react'
import VisibilitySensor from 'react-visibility-sensor'

const RenderItems = props =>  {
    return props.content.map((v,i) => 
        <VisibilitySensor>{
            ({isVisible}) => <div key={i} dangerouslySetInnerHTML={{__html: v.join(" ")}} />
        }</VisibilitySensor>
    )
}

export default RenderItems